module.exports = __webpack_public_path__ + "static/media/unid_licenciatura.63178dff.svg";